import { render, staticRenderFns } from "./PluginAppearance.vue?vue&type=template&id=735880cc&scoped=true&"
import script from "./PluginAppearance.vue?vue&type=script&lang=js&"
export * from "./PluginAppearance.vue?vue&type=script&lang=js&"
import style0 from "./PluginAppearance.vue?vue&type=style&index=0&id=735880cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735880cc",
  null
  
)

export default component.exports